// eslint-disable-next-line eag/match-named-export
import {ReactNode} from 'react';

export type DashboardBlockSidePriority = 'left' | 'right';

export interface DashboardBlock {
  id: string;
  component: ReactNode;
  priority: DashboardBlockSidePriority;
  isVisible: boolean;
}

export type DashboardLayoutConfig = DashboardBlock[];

export type DashboardLayout = {
  left: DashboardLayoutConfig;
  right: DashboardLayoutConfig;
};

export enum DashboardSource {
  activeBranch = 'activeBranch',
  tenant = 'tenant',
}
